import React, {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import CONFIGURACIONES from "../../../util/constants";
import WaveButton from "../WaveButton.jsx";

const ActividadLaboralModal = ({ show, data, onClose, onSave, showCreate, title, list }) => {
    const { handleSubmit: handleSubmitModal, register: registerModal, setValue : setValueModal, formState: { errors: errorsModal } } = useForm({mode: "onChange"});
    const [searchTerm, setSearchTerm] = useState(CONFIGURACIONES.INIT.STRING);
    const [selectedId, setSelectedId] = useState(CONFIGURACIONES.INIT.NULL);

    const filteredData = list.filter((item) =>
        item.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        setValueModal("actividadLaboral", data);
        setSelectedId(CONFIGURACIONES.INIT.NULL);
        setSearchTerm(CONFIGURACIONES.INIT.STRING);
        if (data) {
            let arrData = data.split('@@');
            setSelectedId(parseInt(arrData[0]));
        }

    }, [data]);

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleSubmitModal(onSave)} autoComplete="off">
                    <input type="hidden" name="" {...registerModal("actividadLaboral", { required: OWASP.REQUIRED })}/>
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        {/* 🔎 Buscador */}
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>

                        {/* 📊 Tabla */}
                        <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                            <table className="table table-sm table-hover table-bordered compact-table align-middle text-wrap">
                                <thead className="bg-success text-white">
                            
                                <tr>
                                    <th>Nombre</th>
                                    <th style={{ width: "100px" }}>Seleccionar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item) => (
                                        <tr key={item.id}>
                                            <td className="text-wrap">{item.nombre}</td>
                                            <td className="text-center">
                                                <input
                                                    type="radio"
                                                    name="selectedUser"
                                                    checked={selectedId === item.id}
                                                    onChange={() => {
                                                        setSelectedId(item.id);
                                                        setValueModal("actividadLaboral", `${item.id}@@${item.nombre}`);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center text-muted">
                                            No se encontraron resultados
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default ActividadLaboralModal;
